import { render } from "./PremiumImpactInformation.vue?vue&type=template&id=146343e3&scoped=true"
import script from "./PremiumImpactInformation.vue?vue&type=script&lang=js"
export * from "./PremiumImpactInformation.vue?vue&type=script&lang=js"

import "./PremiumImpactInformation.vue?vue&type=style&index=0&id=146343e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146343e3"]])

export default __exports__